var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconArrowURightUp = function SvgIconArrowURightUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15.043 2.293a1 1 0 0 1 1.414 0l4.5 4.5a1 1 0 0 1-1.414 1.414L16.75 5.414V15.75a6.25 6.25 0 0 1-12.5 0V7.5a1 1 0 0 1 2 0v8.25a4.25 4.25 0 1 0 8.5 0V5.414l-2.793 2.793a1 1 0 1 1-1.414-1.414z"
  })));
};
export default SvgIconArrowURightUp;